module.exports = __webpack_public_path__ + "img/c_2.20197ff1.png";